import { useQuery } from "@tanstack/react-query";

import { ListAudioFilesQueryFilters, UseListAudioFilesQueryOptions } from "./types";
import { getAudioFilesService } from "./service";

export const listAudioFilesQueryKey = ["audiobook_admin"];

export function useListAudioFilesQuery(
  filters?: ListAudioFilesQueryFilters,
  options?: UseListAudioFilesQueryOptions
) {
  const queryKey = listAudioFilesQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getAudioFilesService(filters),
    ...options,
  });
}
